import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Translate from 'client/components/translate';
import { Collapse } from 'react-collapse';
import DetailListItem from 'client/components/plan/detail/listItem';

const propTypes = {
  itemPath: PropTypes.string,
  value: PropTypes.string.isRequired,
  keyElement: PropTypes.element,
  tooltip: PropTypes.element,
};

const defaultProps = {
  itemPath: '',
  keyElement: null,
  tooltip: null,
};

export default class TooltipDetailListItem extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showTooltip: false,
    };
  }

  toggleTooltip(event) {
    event.preventDefault();
    this.setState({
      showTooltip: !this.state.showTooltip,
    });
  }

  render() {
    const { itemPath, value, keyElement, tooltip } = this.props;
    const { showTooltip } = this.state;
    const label = keyElement || (itemPath && <Translate path={itemPath} />);
    const updatedLabel = tooltip ? (
      <div role="link" className="tooltip-link" onClick={event => this.toggleTooltip(event)}>
        { label }<span className="icon-down-open-mini" />
      </div>
    ) : label;

    return (
      <DetailListItem
        label={updatedLabel}
        value={value}
        className={showTooltip ? 'open' : ''}>
        { tooltip &&
          <Collapse
            isOpened={showTooltip}
            springConfig={{ stiffness: 250, damping: 30 }}>
            <div className="tool-tip">
              { tooltip }
            </div>
          </Collapse>
        }
      </DetailListItem>
    );
  }
}

TooltipDetailListItem.propTypes = propTypes;
TooltipDetailListItem.defaultProps = defaultProps;
